import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Textbox } from '../../models/editors/textbox.model';
import { Textarea } from '../../models/editors/textarea.model';
import { atLeastOneLang } from '../../shared/validators/langField.validator';
import { FormControlService } from '../../shared/services/form-control.service';
import { ApiService } from '../../shared/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '../../shared/services/alert.service';
import { FormDetailBase } from '../../shared/components/base/form-detail/form-detail.base.component';
import { Certificate } from '../../models/certs/certificates.model';
import { ContainedMany } from '../../models/editors/contained-many.model';

@Component({
  selector: 'swb-cert-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService],
  encapsulation: ViewEncapsulation.None
})
export class CertDetailComponent extends FormDetailBase<Certificate> implements OnInit {

  public url = 'certificates';
  protected _redirect = './certs';

  public entity = new Certificate({});

  public get fieldsConfig(): Array<any> {
    return [
      new Textbox({
        key: 'title',
        label: 'Titulek',
        validators: [atLeastOneLang],
        isMultilang: true
      }),
      new Textarea({
        key: 'content',
        label: 'Popis',
        validators: [atLeastOneLang],
        isMultilang: true,
        wysiwyg: 'job-detail'
      }),
      new ContainedMany({
        key: 'files',
        label: 'Galerie',
        entities: this.entity.files,
        files: this.entity.files,
        apiUrl: 'files',
        upload: true,
        imgOnly: false
      })
    ];
  }

  public formEditors: any;
  public isInitialized = false;
  public isSaving = false;

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {

    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }

    this._getEntity();

  }


}
